import {Component, OnInit, HostListener, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef, Input} from '@angular/core';
import {CommentboxComponent} from '../commentbox/commentbox.component';
import {IdexService} from '../../../idex.service';
import {DomSanitizer} from '@angular/platform-browser';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {MatLegacyButton as MatButton} from '@angular/material/legacy-button';
import {MomentPipe} from '../../../shared/moment.pipe';
@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.css']
})
export class CommentsComponent implements OnInit {
   @Output() clickDelete = new EventEmitter<any>();
   @Output() selectDrawComment = new EventEmitter<any>();
   @Output() saveCommentTask = new EventEmitter<any>();
   @Output() saveReplyTask = new EventEmitter<any>();
   isHideDeleteBtn: any;
   public unique_key: string;
   public commentBoxRef: CommentboxComponent;
   comment: any;
   reply: any;
   isActive: boolean;
   coordinateY: any;
   signItems: any;
   isHideAction: false;
   @ViewChild('commentText', {static: false}) commentText: ElementRef;
   @ViewChild('replyList', {static: false}) replyList: ElementRef;
   constructor(public service: IdexService, private sanitizer: DomSanitizer, private dialog: MatDialog,
               private changeDetector: ChangeDetectorRef) {
     this.isActive = false;
   }

   @HostListener('click')
   clicked() {
      this.changeDetector.detectChanges();

      if (!this.isActive) {
         this.isActive = true;
         this.selectDrawComment.emit({id: this.unique_key, isActive: this.isActive});
      }
      setTimeout(() => {
         if (this.commentText) {
            this.commentText.nativeElement.focus();
         }
      }, 0 );
   }

  ngOnInit(): void {
     this.comment = [];
     if (this.signItems && this.signItems.comment) {
        this.comment = this.signItems.comment;
     }
  }

   transform(value) {
      return this.sanitizer.bypassSecurityTrustHtml(value);
   }

   onSelectComment(isShow: boolean) {
      this.isActive = isShow;
      setTimeout(() => {
         if (this.commentText && isShow) {
            this.commentText.nativeElement.focus();
         }
      }, 0 );
   }

   postComment(button: MatButton, input: any): void {
      const now = new Date();
      const fmt = new MomentPipe();
      fmt.transform(now, 'DD-MM-YYYY HH:mm:SS');
      const text = input.value.trim();
      if (text.length === 0) {
         input.focus();
         return;
      }
      button.disabled = true;

      if (!(this.comment && this.comment.content)) {
         this.comment = {
            'id': this.signItems.comment && this.signItems.comment.id ? this.signItems.comment.id : 0,
            'content': input.value.toString(),
            'postBy': {
               'name': this.service.user.name,
               'id': this.service.user.email,
               'avatar': this.service.user.avatar
            },
            'postDate': now,
            'modifiedDate': null,
         };
         this.signItems.comment = this.comment;
         this.onSaveCommentTask();
         this.onFinishComment(button, input);
      } else {
         if (!this.comment.reply && this.comment.reply == null) {
            this.comment.reply = [];
         }
         this.reply = {
            'id': this.signItems.comment.reply && this.signItems.comment.reply.id ? this.signItems.comment.reply.id : 0,
            'content': input.value.toString(),
            'postBy': {
               'name': this.service.user.name,
               'id': this.service.user.email,
               'avatar': this.service.user.avatar
            },
            'postDate': now,
            'modifiedDate': null,
         };
         this.comment.reply.push(this.reply);
         this.signItems.comment = this.comment;
         this.onSaveReplyTask();
         this.onFinishComment(button, input);
      }
   }

   onFinishComment(button: MatButton, input: any) {
      try {
         input.value = '';
         setTimeout(() => {
            if (this.replyList) {
               this.replyList.nativeElement.scrollTop = this.replyList.nativeElement.scrollHeight;
            }
            button.disabled = false;
         }, 1500);
      } catch (e) {
         input.value = '';
         button.disabled = false;
         console.error(e);
      }
   }

   onClickDelete() {
      this.clickDelete.emit({fieldType: 'comment'});
   }

   onSaveCommentTask() {
      this.saveCommentTask.emit({signItems: this.signItems});
   }

   onSaveReplyTask() {
      this.saveReplyTask.emit({signItems: this.signItems, reply: this.reply});
   }

   updatePosition(y: any) {
      this.coordinateY = y;
   }
}
